import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { $app } from "@app/app.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '@app/shared/services/config.service';
import { DataService } from './data.service';


@Injectable()
export class PeopleService {


    public httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
        //,withCredentials:true
        //,'Cache-control': 'no-cache'
    };

    constructor(private http: HttpClient, private configSevice: ConfigService, private dataSrv: DataService) { }

    public apiUrl: string = this.configSevice.apiUrl;

    search(data: any): Observable<any> {

        if (data) {

            let params = data;

            return this.http.post<any>(`${this.configSevice.apiUrl}/persons/search`, params, this.httpOptions).pipe(
                map((res: any) => {
                    return {
                        total: res.total_elements,
                        data: res.hasOwnProperty('results') && Array.isArray(res?.results) && (res?.results as any[]).length > 0 ? res.results?.map(row => (this.dataSrv.mapPerson(row))) : []
                    };
                })
            );
        }

        return of(false);
    }

    getById(id: any): Observable<any> {

        return this.http.get(`${this.configSevice.apiUrl}/persons/${id}`, this.httpOptions).pipe(
            map((res: any) => {
                return this.dataSrv.mapPerson(res, 'detail');
            })
        );
    }

    getTeamByPersonId(id: any): Observable<any> {

        return this.http.get(`${this.configSevice.apiUrl}/persons/${id}/team-members`, this.httpOptions).pipe(
            map((res: any) => {

                let resData = {
                    team_name: "",
                    team_persons: []
                };

                if (res && $app.core.code.isArray(res) && res.length) {

                    resData.team_name = res[0].department;
                    resData.team_persons = res.map(row => (this.dataSrv.mapTeamMember(row)));
                }

                return resData;
            })
        );
    }

    getProjectsByPerson(data: any): Observable<any> {

        if (data) {

            let params = data;

            return this.http.post<any>(`${this.configSevice.apiUrl}/projects/search`, params, this.httpOptions).pipe(
                map((res: any) => {
                    console.log('getProjectsByPerson', res)
                    return {
                        total: res.total_results,
                        data: res.hasOwnProperty('results') && Array.isArray(res?.results) && (res?.results as any[]).length > 0 ? res.results?.map(row => (this.dataSrv.mapPersonProject(row))) : []
                    };
                })
            );
        }

        return of(false);
    }

    getClientsByPerson(data: any): Observable<any> {

        if (data) {

            let params = data;

            return this.http.post<any>(`${this.configSevice.apiUrl}/companies/search`, params, this.httpOptions).pipe(
                map((res: any) => {
                    return {
                        total: res.total_elements,
                        data: res.hasOwnProperty('results') && Array.isArray(res?.results) && (res?.results as any[]).length > 0 ? res.results?.map(row => (this.dataSrv.mapPersonClient(row))) : []
                    };
                })
            );
        }

        return of(false);
    }

    dowloadCV(id: any): Observable<any> {

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            reportProgress: true,
            observe: 'events' as 'body',
            responseType: 'blob' as 'json'
        };

        return this.http.get(`${this.configSevice.apiUrl}/persons/${id}/document`, httpOptions);

    }
}
